import React from 'react';
import { HashRouter } from 'react-router-dom';

import LayoutComponent from './components/LayoutComponent';

import './App.scss';

const App = () => {
  return (
    <>
      <HashRouter>
        <LayoutComponent />
      </HashRouter>
    </>
  )
}

export default App;

